require('./release/angular-recaptcha.js');
module.exports = 'vcRecaptcha';



//////////////////
// WEBPACK FOOTER
// ./~/angular-recaptcha/index.js
// module id = 748
// module chunks = 1